/* Social proof de compras reales — UnoKeeper.
   Toasts anónimos ("Alguien en León compró …") con pedidos reales de
   assets/recent-sales.json (regenerado por scripts/sales-proof/generate.py).

   Cero impacto en LCP/TBT: script defer, arranca tras `load` + FIRST_DELAY
   y el fetch del JSON también es diferido. Cero CLS: elemento position:fixed.

   Reglas anti-fastidio:
   - Primer toast 8–12 s tras load; después cada 35–45 s.
   - Máx. 3 por página (2 en móvil), máx. 7 por sesión.
   - Cerrar con × = silencio total el resto de la sesión.
   - Nunca se repite producto en la misma página.
   - Tiempos honestos: >48 h se muestra "recientemente", nunca se inventa.
   - Datos con >10 días sin regenerar → no se muestra nada.

   QA: abrir cualquier página con #uk-sp-test → primer toast a los 1.5 s. */
(function () {
  'use strict';

  var root = document.getElementById('uk-sales-proof');
  if (!root || !window.fetch || !window.sessionStorage || !root.dataset.src) return;

  var TEST = window.location.hash === '#uk-sp-test';
  var MOBILE = window.matchMedia('(max-width: 749px)').matches;

  var CFG = {
    FIRST_DELAY_MS: TEST ? [1500, 1500] : [8000, 12000],
    INTERVAL_MS: TEST ? [8000, 8000] : [35000, 45000],
    VISIBLE_MS: 5500,
    MAX_PER_PAGE: MOBILE ? 2 : 3,
    MAX_PER_SESSION: 7,
    MAX_JSON_AGE_MS: 10 * 24 * 3600 * 1000,
    SS_COUNT: 'uk-sp-count',
    SS_MUTE: 'uk-sp-mute'
  };

  function ss(key, val) {
    try {
      if (arguments.length === 2) { sessionStorage.setItem(key, val); return val; }
      return sessionStorage.getItem(key);
    } catch (e) { return null; }
  }
  function rand(range) {
    return range[0] + Math.random() * (range[1] - range[0]);
  }
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  /* Tiempo relativo honesto en es-MX */
  function timeAgo(iso) {
    var ms = Date.now() - Date.parse(iso);
    if (isNaN(ms) || ms < 0) return 'recientemente';
    var min = Math.round(ms / 60000);
    if (min < 5) return 'hace unos minutos';
    if (min < 90) return 'hace ' + min + ' min';
    var h = Math.round(min / 60);
    if (h < 24) return 'hace ' + h + ' h';
    if (h < 48) return 'ayer';
    return 'recientemente';
  }

  if (ss(CFG.SS_MUTE)) return;
  var sessionCount = parseInt(ss(CFG.SS_COUNT) || '0', 10);
  if (sessionCount >= CFG.MAX_PER_SESSION) return;

  var shownOnPage = 0;
  var pool = null; // se llena tras el fetch diferido

  /* Posición (auditoría sep-2026 #68/#6): encima del cookie banner Y de la sticky
     cart-bar, leyendo las variables que ya publican cookie-banner.liquid
     (--uk-cookie-offset) y whatsapp-float.liquid (--uk-cartbar-offset). Es un calc()
     de CSS: el navegador reacomoda solo cuando aparecen/desaparecen — sin
     getBoundingClientRect (layout forzado) ni MutationObserver. Antes: 92px fijos
     en PDP móvil = el toast tapaba el botón AÑADIR AL CARRITO de la barra mientras
     el banner estaba visible (tap → navegaba a OTRO producto). */
  function bottomOffset() {
    return 'calc(16px + var(--uk-cookie-offset, 0px) + var(--uk-cartbar-offset, 0px))';
  }

  function buildToast(sale) {
    var toast = document.createElement('div');
    toast.className = 'uk-sp' + (root.dataset.pdp ? ' uk-sp--pdp' : '');
    toast.style.bottom = bottomOffset();

    var link = document.createElement('a');
    link.className = 'uk-sp__link';
    link.href = '/products/' + encodeURIComponent(sale.h);

    if (sale.img) {
      var img = document.createElement('img');
      img.className = 'uk-sp__img';
      img.src = sale.img;
      img.alt = '';
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      link.appendChild(img);
    }

    var body = document.createElement('span');
    body.className = 'uk-sp__body';

    var line1 = document.createElement('span');
    line1.className = 'uk-sp__line1';
    if (sale.c) {
      line1.appendChild(document.createTextNode('Alguien en '));
      var b = document.createElement('b');
      b.textContent = sale.c;
      line1.appendChild(b);
      line1.appendChild(document.createTextNode(' compró'));
    } else {
      line1.textContent = 'Alguien compró';
    }
    body.appendChild(line1);

    var title = document.createElement('span');
    title.className = 'uk-sp__title';
    title.textContent = sale.t;
    body.appendChild(title);

    var meta = document.createElement('span');
    meta.className = 'uk-sp__meta';
    // La palomita es la máscara .uk-ok de assets/uk-type.css: el glifo de texto no existe
    // en la Montserrat del CDN y el sistema lo dibujaba con otra fuente.
    meta.classList.add('uk-ok');
    meta.textContent = 'Compra verificada · ' + timeAgo(sale.at);
    body.appendChild(meta);

    link.appendChild(body);
    toast.appendChild(link);

    var close = document.createElement('button');
    close.className = 'uk-sp__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'No mostrar más');
    close.innerHTML = '&times;';
    close.addEventListener('click', function (e) {
      e.preventDefault();
      ss(CFG.SS_MUTE, '1'); // cerró una vez → silencio el resto de la sesión
      hideToast(toast);
    });
    toast.appendChild(close);

    return toast;
  }

  function hideToast(toast) {
    toast.classList.remove('is-in');
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 400);
  }

  function showNext() {
    if (ss(CFG.SS_MUTE)) return;
    if (shownOnPage >= CFG.MAX_PER_PAGE) return;
    if (sessionCount >= CFG.MAX_PER_SESSION) return;
    if (!pool || !pool.length) return;

    // Pestaña oculta: esperar a que vuelva, no quemar el toast en el fondo
    if (document.hidden) {
      document.addEventListener('visibilitychange', function onVis() {
        if (!document.hidden) {
          document.removeEventListener('visibilitychange', onVis);
          setTimeout(showNext, 1500);
        }
      });
      return;
    }

    var sale = pool.shift(); // sin repetir producto en la misma página
    var toast = buildToast(sale);
    root.appendChild(toast);
    // Doble rAF en vez de `void offsetWidth` (reflow síncrono): la transición corre igual
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('is-in'); });
    });

    shownOnPage++;
    sessionCount++;
    ss(CFG.SS_COUNT, String(sessionCount));

    setTimeout(function () { hideToast(toast); }, CFG.VISIBLE_MS);
    if (shownOnPage < CFG.MAX_PER_PAGE && sessionCount < CFG.MAX_PER_SESSION && pool.length) {
      setTimeout(showNext, rand(CFG.INTERVAL_MS));
    }
  }

  function start() {
    fetch(root.dataset.src)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.sales || !data.sales.length) return;
        // Datos abandonados (job caído >10 días) → mejor silencio que mentir
        var age = Date.now() - Date.parse(data.gen || 0);
        if (isNaN(age) || age > CFG.MAX_JSON_AGE_MS) return;
        pool = shuffle(data.sales.slice());
        // Fuera del hilo ocupado: idle (con tope) para no entrar en medio de un tap
        if (window.requestIdleCallback) requestIdleCallback(showNext, { timeout: 3000 });
        else setTimeout(showNext, 0);
      })
      .catch(function () { /* sin red o 404: silencio */ });
  }

  function armFirst() {
    setTimeout(start, rand(CFG.FIRST_DELAY_MS));
  }

  if (document.readyState === 'complete') armFirst();
  else window.addEventListener('load', armFirst);
})();
